
import angular from 'angular';
import CarouselCategoryComponent from './carousel-category.component';

let CarouselCategoryModule = angular.module('home.carouselCategory',[])
.component('carouselCategory',CarouselCategoryComponent);
export default CarouselCategoryModule;



/** WEBPACK FOOTER **
 ** C:/wamp64/www/FRONTENDS/PROYECTOS SIESA/Projects_Azure/motos_paisa/NUEVO/motos-y-motos-el-paisa/www/components/home/carousel-category/carousel-category.js
 **/